var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('d-title',{ref:"title"}),_c('div',{staticClass:"container"},[_c('side-bar'),_c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"wrapperView"},[(_vm.isRouterAlive)?_c('router-view'):_vm._e()],1)])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }